// Single source of truth for how this app identifies itself in transactional
// email. Change these and every branded email follows - nothing lives in the
// Supabase dashboard.
export const BRAND = {
  app_name: 'ConveyMed',
  brand_dark: '#10069D',
  brand_light: '#00B4E0',
  app_url: window.location.origin,
};
